var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-container"},[_c('div',{staticClass:"content"},_vm._l((_vm.gridData),function(article,index){return _c('PassCard',{key:index,attrs:{"article":article}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }